import { useState, useEffect } from "react";
import { logsService } from "../services/logs.service";
import { fetchFileObjectUrl } from "../utils/file";

type FileType = "pdf" | "image" | "other";

interface FilePreviewState {
  isPdf: boolean;
  isImage: boolean;
  fileType: FileType;
  dataUrl: string | null;
  directFileUrl: string | null;
  fileError: string | null;
}

function getFileType(fileName: string): FileType {
  const lower = fileName.toLowerCase();
  if (lower.endsWith(".pdf")) return "pdf";
  if (lower.endsWith(".jpg") || lower.endsWith(".jpeg") || lower.endsWith(".png")) return "image";
  return "other";
}

export const usePdfPreview = (colocId: string | undefined, fileName: string | undefined) => {
  const [state, setState] = useState<FilePreviewState>({
    isPdf: false,
    isImage: false,
    fileType: "other",
    dataUrl: null,
    directFileUrl: null,
    fileError: null,
  });

  useEffect(() => {
    if (!colocId || !fileName) return;

    const fileType = getFileType(fileName);
    setState((prev) => ({
      ...prev,
      isPdf: fileType === "pdf",
      isImage: fileType === "image",
      fileType,
    }));

    if (fileType === "other") return;

    let directUrl: string | null = null;
    let annule = false;
    const fetchUrls = async () => {
      try {
        const dataUrlResult = await logsService.getFileAsDataUrl(colocId, fileName);
        setState((prev) => ({ ...prev, dataUrl: dataUrlResult }));
      } catch {
        // silent
      }

      try {
        const url = await fetchFileObjectUrl(colocId, fileName);
        // Page quittée pendant le téléchargement : rien à afficher.
        if (annule) {
          URL.revokeObjectURL(url);
          return;
        }
        directUrl = url;
        setState((prev) => ({ ...prev, directFileUrl: url }));
      } catch {
        // silent
      }
    };

    fetchUrls();
    return () => {
      annule = true;
      if (directUrl) URL.revokeObjectURL(directUrl);
    };
  }, [colocId, fileName]);

  return state;
};
